import { render, staticRenderFns } from "./NotificationsImages.vue?vue&type=template&id=dd3719d6"
import script from "./NotificationsImages.vue?vue&type=script&lang=js"
export * from "./NotificationsImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports